import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios'
import { API_PRODUCT_ALIASES } from '../../../../consts'
import { to } from '../../../../utils/to'

interface RemapAliasPayload {
  product_id: number | string
}

interface RemapAliasResponse {
  alias: { id: number; product_id: number; name: string }
}

export const remapAlias = async (aliasId: number | string, productId: number | string) => {
  const payload: RemapAliasPayload = { product_id: productId }

  const request: AxiosRequestConfig = {
    url: `${API_PRODUCT_ALIASES}/${aliasId}/remap`,
    method: 'POST',
    data: payload,
    headers: { 'content-type': 'application/json' },
    withCredentials: true,
  }

  return await to<AxiosResponse<RemapAliasResponse>, AxiosError>(axios(request))
}
